<template>
<div>
	<!-- Start 通用底部悬浮导航 -->
    <nav class="fix-nav cbox" v-if="isShowFooter">

        <li v-bind:class="{'active': active == 1}" @click="go(1)">
        	<router-link :to="linkObj">
        		<span href="javascript:void(0)"><i class="ico-nav-home"></i>首页</span>
        	</router-link>
        </li>
        <li v-bind:class="{'active': active == 2}" v-on:click='go(2)'>
        	<!-- <router-link :to="courseObj">
        		<span href="javascript:void(0)"><i class="ico-nav-course"></i>选课中心</span>
        	</router-link> -->
        </li>
        <li v-bind:class="{'active': active == 3}" @click="go(3)">
			<router-link :to="{name: 'mine'}">
        		<span href="javascript:void(0)"><i class="ico-nav-my"></i>我的</span>
        	</router-link>
        </li>
    </nav>
    <!-- End 通用底部悬浮导航 -->
</div>
</template>
<script>
	import '@/components/common/css/footer.css';
import {mapState} from 'vuex';
	export default{
	  name: 'Footer',
	  data() {
	    return {
      active: 1,
      linkObj: {name: 'Home'},
      courseObj: {name: 'courses'}
	    }
	  },
  computed: mapState({
    isShowFooter: state => state.footer.isShowFooter,
    city: state => state.home.city
  }),
  watch: {
    $route() {
      this.judged();
      document.getElementById('app').scrollIntoView({block: 'start', behavior: 'smooth'});
    },
    city() {
      if (this.city.city_code == '0086') {
        this.linkObj = {name: 'notOnline'}
        this.courseObj = {name: 'qtCourses'}
      } else {
        this.linkObj = {name: 'Home'}
        this.courseObj = {name: 'courses'}
      }
    }
  },
  methods: {
    go(num) {
      if (this.active == num) {
        return;
      }
      this.active = num;
      //启用loading
      this.$store.commit('isShowLoading', true);
    },
    judged() {
      let name = this.$route.name;

      if (name == 'Home' || name == 'notOnline') {
        this.active = 1;
      } else if (name == 'mine' || name == 'login' || name == 'reset') {
        this.active = 3;
      } else {
        this.active = 2;
      }
    }
  },
  mounted() {
    this.judged();
  }
	}
</script>


// WEBPACK FOOTER //
// src/components/public/footer/Footer.vue